import React from 'react';
import { faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons';
import svgRect from '#src/static/home_rect.png';

import { HomeWrapper, Intro } from './Home.style';
import IconLink from '#common/IconLink';
import Button from '#common/Button';

const Home = () => {
  return (
    <HomeWrapper id="home">
      <img className="svg-rect" src={svgRect} alt=""></img>
      <Intro>
        <div className="home__text">
          <p>Hello, i’m</p>
          <h1>SAMAR TEKAYA</h1>
          <p className="adjust">CEO & FOUNDER OF SAMCODING</p>
          <p className="adjust">FRONT-END DEVELOPER</p>
          <p className="adjust">CONTENT CREATOR</p>

          <div className="home__CTA">
            <Button className="cta" target="__blank" as="a" href="//youtube.com/samartekaya?sub_confirmation=1">
              Subscribe Now!
            </Button>

            <div className="home__social">
              <IconLink label="linkedin" icon={faLinkedin} href="//linkedin.com/in/tekayasamar" />
              <IconLink label="twitter" icon={['fab', 'twitter']} href="//twitter.com/tekayasamar" />
              <IconLink label="facebook" icon={['fab', 'facebook']} href="//facebook.com/tekayasamarofficial" />
              <IconLink label="instagram" icon={faInstagram} href="//instagram.com/samar_tekaya_official" />
            </div>
          </div>
        </div>
      </Intro>
    </HomeWrapper>
  );
};

export default Home;
